import { useTranslation } from 'react-i18next';

export default function VisionSection() {
  const { t } = useTranslation();

  const points = [
    { key: 'vision.point1', icon: 'ri-building-2-line' },
    { key: 'vision.point2', icon: 'ri-award-line' },
    { key: 'vision.point3', icon: 'ri-ruler-line' },
    { key: 'vision.point4', icon: 'ri-base-station-line' },
    { key: 'vision.point5', icon: 'ri-global-line' },
  ];

  return (
    <section className="relative py-20 md:py-28 bg-primary-900 overflow-hidden">
      {/* Subtle texture overlay */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.8) 1px, transparent 1px)',
        backgroundSize: '40px 40px'
      }}></div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
            {/* President Photo / Image */}
            <div className="w-full lg:w-2/5 flex-shrink-0">
              <div className="relative">
                <div className="w-64 h-64 md:w-72 md:h-72 mx-auto lg:mx-0 rounded-2xl overflow-hidden border-2 border-accent-500/30">
                  <img
                    src="https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/c7bdcb3ed87590029d6e0640a43364dd.jpeg"
                    alt="Baby Olivier Pandja — Président du Tennis Club de Douala"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                {/* Decorative accent line */}
                <div className="absolute -bottom-3 -right-3 w-24 h-24 border-2 border-accent-500/20 rounded-2xl hidden lg:block"></div>
                <div className="absolute -top-3 -left-3 w-16 h-16 border-2 border-accent-500/10 rounded-2xl hidden lg:block"></div>
              </div>
              <p className="text-center lg:text-left mt-5 font-heading text-xl text-background-50 font-semibold">Baby Olivier Pandja</p>
              <p className="text-center lg:text-left text-sm text-accent-400/80 tracking-wide uppercase">{t('vision.subtitle')}</p>
            </div>

            {/* Content */}
            <div className="flex-1 text-center lg:text-left">
              <p className="text-xs md:text-sm tracking-[0.2em] uppercase text-accent-400 font-medium mb-3">
                {t('vision.title')}
              </p>
              <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-6">
                {t('vision.subtitle')}
              </h2>
              <p className="text-base md:text-lg text-background-50/70 leading-relaxed mb-8 max-w-xl lg:max-w-none font-light italic">
                &ldquo;{t('vision.quote')}&rdquo;
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8">
                {points.map((point, idx) => (
                  <div key={idx} className="flex items-start gap-3 p-3 rounded-xl bg-primary-800/40 border border-primary-700/30 transition-all duration-300 hover:border-accent-500/20">
                    <div className="w-7 h-7 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-500/15 text-accent-400 mt-0.5">
                      <i className={`${point.icon} text-sm`}></i>
                    </div>
                    <span className="text-sm text-background-50/80 leading-snug">{t(point.key)}</span>
                  </div>
                ))}
              </div>

              <a
                href="/about"
                className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold rounded-full bg-accent-500 text-background-50 hover:bg-accent-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                {t('vision.cta')}
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}